import AnalyticsCharts from "./analytics/AnalyticsCharts";
import LandingSectionHeader from "./LandingSectionHeader";
import {
  getConversionRate,
  getLandingDemoCharts,
} from "../utils/analyticsCharts";

const LANDING_STATS = [
  { label: "Запусков", value: "847" },
  { label: "Завершений", value: "612" },
  { label: "Уникальных сотрудников", value: "523" },
];

const LANDING_FEATURES = [
  "Видно, кто прошёл программу до конца, а кто остановился на полпути",
  "Сильные и слабые стороны команды — понятно, где люди уверены, а где ошибаются чаще",
  "Пробелы в знаниях видны сразу — можно вовремя скорректировать обучение",
  "Точки выхода и сложные места — понятно, какие темы и сцены переработать",
  "Рейтинг и лидеры — кого отметить, кого мотивировать, кого назначить наставником",
  "Динамика по дням для отчётов HR и руководителей",
];

export default function LandingAnalyticsSection() {
  const charts = getLandingDemoCharts();
  const conversionRate = getConversionRate(charts.completionSplit);

  return (
    <section
      id="analytics"
      className="landing-band landing-band--analytics landing-section landing-section--analytics"
    >
      <div className="landing-container">
        <LandingSectionHeader
          label="07 · Аналитика"
          title="Видно, кто прошёл, где команда сильна и где нужна поддержка"
          desc="Запуски, завершения, воронка и проблемные места — в наглядных графиках. Помогает расставить акценты в обучении, закрыть пробелы в знаниях, мотивировать команду и выбрать лидеров."
        />

        <div className="landing-band__panel landing-band__panel--analytics">
        <div className="landing-analytics">
          <div className="landing-analytics__intro">
            <span className="landing-analytics__badge">Пример отчёта</span>
            <p>
              После запуска базы знаний, сценария или тренажёра вы получаете
              статистику по каждому прохождению. HR видит прогресс команды,
              сильные и слабые стороны, а также точки, где стоит усилить
              обучение — без ручного сбора данных.
            </p>
          </div>

          <div className="landing-analytics__summary">
            {LANDING_STATS.map((item) => (
              <div className="landing-analytics__stat" key={item.label}>
                <span className="landing-analytics__stat-label">
                  {item.label}
                </span>
                <strong className="landing-analytics__stat-value">
                  {item.value}
                </strong>
              </div>
            ))}
            <div className="landing-analytics__stat landing-analytics__stat--accent">
              <span className="landing-analytics__stat-label">Конверсия</span>
              <strong className="landing-analytics__stat-value">
                {conversionRate}%
              </strong>
            </div>
          </div>

          <div className="landing-analytics__charts-panel">
            <AnalyticsCharts charts={charts} />
          </div>

          <ul className="landing-analytics__features">
            {LANDING_FEATURES.map((feature) => (
              <li key={feature}>{feature}</li>
            ))}
          </ul>
        </div>
        </div>
      </div>
    </section>
  );
}
